export default __webpack_public_path__ + "static/gi1-18cdd25bd1c38197865c8bcaa8be1b43.gif";